import React, { memo, useState } from 'react'
import { AutoComplete } from 'antd'
import { getImplementationSuggestions } from '../../services/implementation-items'

const SuggestionAutocomplete = ({ value, onChange }) => {
  const [suggestions, setSuggestions] = useState([])
  const onSuggestionSearch = (searchText) => {
    if (searchText?.length === 0) {
      setSuggestions([])
    } else {
      getImplementationSuggestions(searchText).then((response) => {
        if (response?.data?.suggestions) {
          setSuggestions(response?.data?.suggestions?.map((item) => ({ value: item.name })))
        }
      })
    }
  }

  return (
    <AutoComplete
      value={value}
      onChange={onChange}
      onSearch={onSuggestionSearch}
      options={suggestions}
      dropdownMatchSelectWidth={false}
      allowClear
    />
  )
}

export default memo(SuggestionAutocomplete)
